import React from 'react';
import { Button } from 'theme-ui';
import HamburgerIcon from '~/assets/images/icons/hamburger.svg';
import CloseIcon from '~/assets/images/icons/x.svg';

type Props = {
  transparentNav: boolean;
  isAtTopOfPage: boolean;
  setTouchStarted: (value: boolean) => void;
  touchStarted: boolean;
  color: string;
  isMenuOpen: boolean;
  toggleMenu: () => void;
};

const HamburgerButton = ({
  touchStarted,
  transparentNav,
  isAtTopOfPage,
  color,
  toggleMenu,
  setTouchStarted,
  isMenuOpen,
}: Props) => {
  return (
    <Button
      variant="bare"
      sx={{
        display: [null, null, 'none'],
        minWidth: 0,
        minHeight: 0,
        width: ['4.8rem', null, '2.4rem'],
        height: '100%',
        svg: {
          width: '1.6rem',
          path: {
            stroke: touchStarted ? 'UIGray1' : transparentNav && isAtTopOfPage ? color : 'black',
            transition: 'fill 0.1s ease-in-out',
          },
        },
        WebkitTapHighlightColor: 'transparent',
      }}
      onClick={toggleMenu}
      onTouchStartCapture={() => setTouchStarted(true)}
      onTouchEndCapture={() =>
        setTimeout(() => {
          setTouchStarted(false);
        }, 250)
      }
      aria-label="Open Menu"
    >
      {isMenuOpen ? <CloseIcon /> : <HamburgerIcon />}
    </Button>
  );
};

export default HamburgerButton;
